<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-13 09:23:25
 * @LastEditors: Betway huangbo@mrcdevlab.com
 * @LastEditTime: 2026-03-31 09:43:04
-->
<template>
  <div>
    <mrc_ess_table
      v-if="$route.name == 'staffType'"
      :headers="headers"
      pageName="addStaffType"
      :paginationOptions="options"
      @turnPage="getlist"
      :hideAddBtn="!hasBtn('add-staff-type')"
      :isLoading="loading"
      :slotKey="['staff_type_name', 'staff_type_description']"
      :items="desserts"
    >
      <template v-slot:btns>
        <mrc_ess_uploadBtn
          type="6"
          :hrefUrl="uploadUrl"
          class="ml-4"
          v-btnAuth="['import-staff-type']"
          :label="$t('label_Batch_Import')"
        ></mrc_ess_uploadBtn>
      </template>

      <template v-slot:search>
        <v-row
          class="d-flex justify-end"
          style="
            background: white;
            margin: 0;
            border-top-right-radius: 8px;
            border-top-left-radius: 8px;
            padding: 0 16px;
          "
        >
          <mrc_ess_advanceFilterAndSearchInput
            class="mt-4"
            v-model="systemSeniorQueryString"
            @success="getlist({ cpage: 1 })"
            :systemFieldMeta="systemFieldMeta"
          ></mrc_ess_advanceFilterAndSearchInput>
        </v-row>
      </template>
      <template v-slot:item.staff_type_name="{ item }">
        {{ INT(item.staff_type_name) }}
      </template>

      <template v-slot:item.staff_type_description="{ item }">
        {{ INT(item.staff_type_description) }}
      </template>
      <!-- 操作 -->
      <template v-slot:item.actions="{ item }">
        <menu-list :list="menulist" @handleClick="handleClick($event, item)">
          <template v-slot:showAction>
            <v-icon
              v-btnAuth="['view-staff-type', 'edit-staff-type', 'delete-staff-type']"
            >
              mdi-dots-vertical
            </v-icon>
          </template>
        </menu-list>
      </template>
    </mrc_ess_table>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import { staff_type_list, staff_type_delete } from "@/service/api/staffType.js";
import { STAFF_TYPE_URL } from "@/utils/constant/index.js";
import { getStaffListForFilter } from "@/service/api/autoComplete.js";
import { getBusinessList } from "@/service/api/prompt.js";
export default {
  components: {},
  props: {},
  data() {
    return {
      uploadUrl: "",
      systemFieldMeta: [],
      field_alias_name: null,
      table_alias_name: null,
      systemSeniorQueryString: [],
      stepIndex: 1,
      dialog: false,
      disabled: true,
      list: {},
      options: {
        pagesize: 5, //条数
        cpage: this.$store.state.cpage, //页数
        totalcount: null, //总条数
        totalpage: null, //总页数
      },
      loading: false,
      desserts: [],
    };
  },
  computed: {
    menulist() {
      return [
        {
          name: this.$t("label_View"),
          show: this.hasBtn("view-staff-type"),
          type: "view",
        },
        {
          name: this.$t("label_Edit"),
          show: this.hasBtn("edit-staff-type"),
          type: "edit",
        },
        {
          name: this.$t("label_delete"),
          show: this.hasBtn("delete-staff-type"),
          type: "del",
        },
      ];
    },
    headers() {
      return [
        {
          text: this.$t("label_staff_type_name"),
          align: "start",
          value: "staff_type_name",
          sortable: false,
        },
        {
          text: this.$t("label_code"),
          value: "staff_type_code",
          sortable: false,
          align: "start",
        },
        {
          text: this.$t("label_describe"),
          value: "staff_type_description",
          sortable: false,
          align: "start",
        },
        {
          text: "",
          value: "actions",
          sortable: false,
          align: "end",
          width: "100",
        },
      ];
    },
  },
  beforeCreate() {
    this.$store.commit("setCpage", 1);
  },
  async created() {
    await this.getBtnPermissionList();
  },
  watch: {
    $route(v) {
      if (v.name == "staffType") {
        this.getlist();
      }
    },
  },
  async mounted() {
    this.uploadUrl = STAFF_TYPE_URL;
    this.loading = true;
    await this.getlist();
    this.loading = false;
  },
  beforeDestroy() {
    this.$ls.remove("staffList");
  },
  methods: {
    async getlist(obj) {
      this.loading = true;
      if (
        this.desserts &&
        this.desserts.length == 1 &&
        this.options.cpage != 1 &&
        this.$route.params.type == "del"
      )
        this.options.cpage--;
      if (obj) {
        const { cpage, pagesize } = obj;
        this.options = { ...this.options, ...obj };
      }
      const res = await staff_type_list({
        cpage: this.options.cpage,
        pagesize: this.options.pagesize,
        systemSeniorQueryString: this.systemSeniorQueryString,
        field_alias_name: this.field_alias_name,
        table_alias_name: this.table_alias_name,
      });
      if (res.code == 200) {
        this.desserts = res.data;
        this.options.totalcount = res.totalcount;
        this.options.totalpage = res.totalpage;
        this.systemFieldMeta = res.systemFieldMeta;
        this.field_alias_name = res.field_alias_name;
        this.table_alias_name = res.table_alias_name;
      }
      this.loading = false;
    },
    godetail(item) {
      this.$store.commit("set_iconstatus", true); //行内进图标显示
      this.$store.commit("set_subPage_name", item.show_name);
      this.$store.commit("set_uuid", item.uuid); //
      this.$router.push({
        name: "detailStaffType",
      });
    },
    handleClick({ item }, obj) {
      switch (item.type) {
        case "view":
          this.godetail(obj);
          break;
        case "edit":
          this.$store.commit("set_subPage_name", obj.show_name);
          this.$store.commit("set_iconstatus", false); //行内进图标显示
          this.$store.commit("set_uuid", obj.uuid); //
          this.$router.push({
            name: "detailStaffType",
          });
          break;
        case "del":
          this.$myConfirm({
            content: this.$t("message_Confirm_the_deletion"),
          }).then((res) => {
            staff_type_delete({ uuid: obj.uuid }).then((res) => {
              if (res.code === "200") {
                this.$Message({
                  text: this.$t("message_The_deletion_was_successful"),
                });
                if (this.desserts.length == 1) this.options.cpage--;
                this.getlist();
              }
            });
          });
          break;
      }
    },
    success() {},
    cancel() {},
  },
};
</script>

<style scoped>
.cardtitle {
  position: relative;
}

.emailbtn {
  position: absolute;
  right: 70px;
  top: -50px;
}

.dowanTemplate {
  position: absolute;
  right: 180px;
  top: -50px;
}
</style>
